import client from "../Client/HttpClient";

const ApiPath = "PreschoolReportScores";

export default {
    async PrintPreschoolReport(payload: any): Promise<any> {
        const response = await client.post(`${ApiPath}/Generate`, payload, {
            responseType: "blob"
        });
        return response.data;
    }
};
